// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"a511b26e","57":"801a6230","139":"a511b26e","252":"06f42002","559":"a511b26e","560":"688142a9","580":"a511b26e","651":"a511b26e","757":"a511b26e","772":"a511b26e","784":"80293da8","925":"877988f9","974":"078fc31e"}[chunkId] + ".chunk.css";
};